import React from 'react';
import styles from "./Potable.module.css";
import { formateDate } from '../../../../Website/utils/utils';

const PoTable = ({ data, orderDetails, setSelectedItems, selectedItems, status }) => {

    const toggleSelection = (item) => {
        setSelectedItems(prevSelected => {
            const isAlreadySelected = prevSelected?.some(selected => selected._id === item._id);

            if (isAlreadySelected) {
                return prevSelected?.filter(selected => selected._id !== item._id);
            } else {
                return [...prevSelected, item];
            }
        });
    };

    const isSelected = (item) => {
        return selectedItems?.some(selected => selected._id === item._id);
    };

    return (
        <div style={{ width: '100%', overflowX: 'auto' }}>
            <table className={styles.previewtable} style={{ width: '100%', borderCollapse: 'separate', borderSpacing: '0 8px' }}>
                <thead>
                    <tr style={{ background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                        <th style={{ padding: '12px 16px', fontSize: '13px', fontWeight: '600', color: '#475569', textAlign: 'left', background: '#f8fafc', borderRadius: '8px 0 0 8px' }}>Part #</th>
                        <th style={{ padding: '12px 16px', fontSize: '13px', fontWeight: '600', color: '#475569', textAlign: 'left', background: '#f8fafc' }}>PO price</th>
                        <th style={{ padding: '12px 16px', fontSize: '13px', fontWeight: '600', color: '#475569', textAlign: 'left', background: '#f8fafc' }}>Manufacture</th>
                        <th style={{ padding: '12px 16px', fontSize: '13px', fontWeight: '600', color: '#475569', textAlign: 'left', background: '#f8fafc' }}>Total Qty</th>
                        <th style={{ padding: '12px 16px', fontSize: '13px', fontWeight: '600', color: '#475569', textAlign: 'left', background: '#f8fafc' }}>Pending Quantity</th>
                        <th style={{ padding: '12px 16px', fontSize: '13px', fontWeight: '600', color: '#475569', textAlign: 'left', background: '#f8fafc', borderRadius: '0 8px 8px 0' }}>Schedule date</th>
                    </tr>
                </thead>
                <tbody>
                    {data?.map((item) => (
                        <React.Fragment key={item._id || item.id}>
                            {item?.rescheduled !== true && (
                                <tr
                                    className={`${styles.previewstripedRow} ${isSelected(item) ? styles.selectedRow : ""}`}
                                    style={{ background: '#ffffff', borderBottom: '1px solid #f1f5f9' }}
                                >
                                    <td style={{ padding: '14px 16px', fontSize: '13.5px', color: '#0f172a', fontWeight: '600' }}>
                                        <div style={{ display: 'flex', gap: "10px", alignItems: 'center' }}>
                                            {(status === "PENDING" || status === "APPROVED" || status === "RESCHEDULE" || status === "AWAITING") && (
                                                <input
                                                    type="checkbox"
                                                    checked={isSelected(item)}
                                                    onChange={() => toggleSelection(item)}
                                                    style={{ width: '16px', height: '16px', cursor: 'pointer', accentColor: '#512DA8' }}
                                                />
                                            )}
                                            <div style={{ width: 42, height: 42, borderRadius: '8px', overflow: 'hidden', border: '1px solid #e2e8f0', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#ffffff', flexShrink: 0 }}>
                                                {item?.productId?.assets?.image ? (
                                                    <img
                                                        src={item?.productId?.assets?.image[0]}
                                                        style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                                                        alt="product"
                                                    />
                                                ) : (
                                                    <img
                                                        src="/assets/profile.png"
                                                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                        alt="default"
                                                    />
                                                )}
                                            </div>
                                            <div>
                                                <span style={{ color: '#0f172a', fontWeight: '600' }}>
                                                    {item?.productId?.productOverview?.productNumber?.[0] || 'Part Item'}
                                                </span>
                                            </div>
                                        </div>
                                    </td>
                                    <td style={{ padding: '14px 16px', fontSize: '13.5px', color: '#0f172a', fontWeight: '600' }}>
                                        ₹{item?.unitPrice}
                                    </td>
                                    <td style={{ padding: '14px 16px', fontSize: '13.5px', color: '#475569' }}>
                                        {item?.productId?.productOverview?.manufacturer?.[0]?.name || '-'}
                                    </td>
                                    <td style={{ padding: '14px 16px', fontSize: '13.5px', color: '#0f172a', fontWeight: '600' }}>
                                        {item?.totalQty}
                                    </td>
                                    <td style={{ padding: '14px 16px', fontSize: '13.5px', color: '#475569' }}>
                                        <span style={{ color: '#0f172a', fontWeight: '600' }}>{item?.pendingOrderCount}</span>
                                        {item?.productId?.inventory?.qtyAvailable !== undefined && (
                                            <div style={{ fontSize: '11px', color: '#94a3b8', marginTop: '2px' }}>
                                                {item?.productId?.inventory?.qtyAvailable} in stock
                                            </div>
                                        )}
                                    </td>
                                    <td style={{ padding: '14px 16px', fontSize: '13.5px', color: '#475569' }}>
                                        <div style={{ color: '#0f172a', fontWeight: '500' }}>
                                            {formateDate(item?.deliveryDate)}
                                        </div>
                                        {item?.lastDeliveryDate && (
                                            <div style={{ fontSize: '11px', color: '#94a3b8', marginTop: '2px' }}>
                                                {formateDate(item?.lastDeliveryDate)} last dispatch
                                            </div>
                                        )}
                                    </td>
                                </tr>
                            )}

                            {item?.rescheduled === true && (
                                <>
                                    <tr style={{ background: 'rgba(81, 45, 168, 0.04)' }}>
                                        <td colSpan={6} style={{ padding: '10px 16px', fontSize: '12px', fontWeight: '600', color: '#512DA8' }}>
                                            Reschedule Details • Required Qty: {item?.rescheduledQuantity} • Reschedule Date: {formateDate(item?.rescheduleDate)}
                                        </td>
                                    </tr>
                                    <tr style={{ background: '#ffffff', borderBottom: '1px solid #f1f5f9' }}>
                                        <td style={{ padding: '14px 16px', fontSize: '13.5px', color: '#0f172a', fontWeight: '600' }}>
                                            <div style={{ display: 'flex', gap: "10px", alignItems: 'center' }}>
                                                <div style={{ width: 42, height: 42, borderRadius: '8px', overflow: 'hidden', border: '1px solid #e2e8f0', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#ffffff', flexShrink: 0 }}>
                                                    {item?.productId?.assets?.image ? (
                                                        <img
                                                            src={item?.productId?.assets?.image[0]}
                                                            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                                                            alt="product"
                                                        />
                                                    ) : (
                                                        <img
                                                            src="/assets/profile.png"
                                                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                            alt="default"
                                                        />
                                                    )}
                                                </div>
                                                <div>
                                                    <span style={{ color: '#0f172a', fontWeight: '600' }}>
                                                        {item?.productId?.productOverview?.productNumber?.[0] || 'Part Item'}
                                                    </span>
                                                </div>
                                            </div>
                                        </td>
                                        <td style={{ padding: '14px 16px', fontSize: '13.5px', color: '#0f172a', fontWeight: '600' }}>
                                            ₹{item?.unitPrice}
                                        </td>
                                        <td style={{ padding: '14px 16px', fontSize: '13.5px', color: '#475569' }}>
                                            {item?.productId?.productOverview?.manufacturer?.[0]?.name || '-'}
                                        </td>
                                        <td style={{ padding: '14px 16px', fontSize: '13.5px', color: '#0f172a', fontWeight: '600' }}>
                                            {item?.totalQty}
                                        </td>
                                        <td style={{ padding: '14px 16px', fontSize: '13.5px', color: '#475569' }}>
                                            <span style={{ color: '#0f172a', fontWeight: '600' }}>{item?.pendingOrderCount}</span>
                                            {item?.productId?.inventory?.qtyAvailable !== undefined && (
                                                <div style={{ fontSize: '11px', color: '#94a3b8', marginTop: '2px' }}>
                                                    {item?.productId?.inventory?.qtyAvailable} in stock
                                                </div>
                                            )}
                                        </td>
                                        <td style={{ padding: '14px 16px', fontSize: '13.5px', color: '#475569' }}>
                                            <div style={{ color: '#0f172a', fontWeight: '500' }}>
                                                {formateDate(item?.deliveryDate)}
                                            </div>
                                            {item?.lastDeliveryDate && (
                                                <div style={{ fontSize: '11px', color: '#94a3b8', marginTop: '2px' }}>
                                                    {formateDate(item?.lastDeliveryDate)} last dispatch
                                                </div>
                                            )}
                                        </td>
                                    </tr>
                                </>
                            )}
                        </React.Fragment>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default PoTable;
